
<template>
  <!-- 货架列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="btnList1" ref="btnList">
      <el-button
        v-if="hasPermiss('zjck_cangKuHuoJia:add')"
        class="itemBtn btnColor"
        @click="addItem"
        >新建</el-button
      >
      <el-button
        v-if="hasPermiss('zjck_cangKuHuoJia:update')"
        class="itemBtn btnColor"
        @click="updateItem"
        >修改</el-button
      >
      <el-button
        v-if="hasPermiss('zjck_cangKuHuoJia:del')"
        class="itemBtn btnColor"
        @click="deletebut"
        >删除</el-button
      >
      <el-button class="itemBtn btnColor" @click="myModel">列表设置</el-button>
      <el-button
        v-if="hasPermiss('zjck_cangKuHuoJia:print')"
        class="itemBtn btnColor"
        @click="printHuoJia"
        >打印货架</el-button
      >
      <el-dropdown @command="handleCommand_dc">
        <el-button class="dropdownBtn">
          导出<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="dc">导出</el-dropdown-item>
          <el-dropdown-item command="dcmb">下载导出模板</el-dropdown-item>
          <el-dropdown-item command="scmb">保存(上传)模板</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 查询条件框 -->
    <el-form :model="queryData">
      <div
        ref="queryCriteria"
        class="HeadInputbox"
        :class="{ HeadInputbox1: judge, active: isActive }"
      >
        <div class="item_right">
          <div class="singleinp">
            <div class="singleinpleft">仓库名称:</div>
            <div class="singleinpright">
              <el-select
                class="queryInput"
                v-model="queryData.storageName"
                filterable
                clearable
                placeholder="请选择"
                @change="changeStorageId"
              >
                <el-option
                  v-for="item in storageAddr"
                  :key="item.id"
                  :label="item.storageName"
                  :value="item.storageName"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="singleinp">
            <div class="singleinpleft">货区名称:</div>
            <div class="singleinpright">
              <el-select
                class="queryInput"
                v-model="queryData.cargoareaName"
                filterable
                clearable
                placeholder="请选择"
                @change="changeHuoQue"
              >
                <el-option
                  v-for="item in storageAreas"
                  :key="item.cargoareaId"
                  :label="item.cargoareaName"
                  :value="item.cargoareaName"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="singleinp">
            <div class="singleinpleft">货架名称:</div>
            <div class="singleinpright">
              <el-input
                class="queryInput"
                clearable
                v-model="queryData.frameName"
                placeholder="请输入货架名称"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="item_left" v-if="hasPermiss('zjck_cangKuHuoJia:query')">
          <div class="singleinpbtn">
            <el-button
              class="seniorbut"
              @click="queryBtn_ok"
              icon="el-icon-search"
              >查询</el-button
            >
            <el-tooltip content="查询项恢复初始状态" placement="top">
              <div class="condition" @click="queryBtn_cz">清除</div>
            </el-tooltip>
            <!-- <el-tooltip content="查询更多条件" placement="top">
              <div class="condition" @click="more">
                {{ MoreConditions }}
              </div>
            </el-tooltip> -->
          </div>
        </div>
      </div>
    </el-form>

    <!-- 表格 -->
    <div class="tableBox" ref="tableWrapper">
      <el-table
        :height="tableHeigth"
        ref="mytable"
        :data="tableData"
        show-summary
        :summary-method="getSummaries"
        :row-class-name="tableRowClassName"
        highlight-current-row
        :header-cell-style="{ background: '#f0f0f0' }"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column fixed="left" type="selection" width="60">
        </el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            sortable
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageNum"
      :total="total"
      :sizeList="sizeList"
      :size="size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!-- //排序 -->
    <div>
      <sorttable
        :show_sortTableHeard="show_sortTableHeard"
        :allCheck="allCheck"
        :sortName="sortName"
        :tabelHeadeTitle="tabelHeadeTitle"
        :originalTabelHeadeTitle="originalTabelHeadeTitle"
        :selectLength="selectLength"
        @cancelSortHeard="cancelSortHeard"
        @confirmOk="confirmOk"
        @checktab="checktab"
        @checkAll="checkAll"
        @closeDias="closeDias"
      ></sorttable>
    </div>
    <div>
      <el-dialog
        title="上传编辑好的导出模板"
        :visible.sync="show_upload"
        append-to-body
        width="40%"
        center
      >
        <div>
          <el-upload
            :action="uploadUrl"
            :show-file-list="true"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSectionFile"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">上传模板</div>
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="show_upload = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 新建 -->
    <el-dialog
      :title="subTitle"
      :visible.sync="show_cate"
      :before-close="closebut"
      :modal-append-to-body="false"
    >
      <div class="newForm">
        <el-form
          label-width="120px"
          ref="formCate"
          label-position="right"
          :model="infosForm"
          :rules="infoRules"
          status-icon
        >
          <div class="queryItem1">
            <el-form-item label="货架编号:" prop="number">
              <el-input
                v-model="infosForm.number"
                :disabled="subTitle == '修改货架'"
              ></el-input>
            </el-form-item>
          </div>
          <div class="queryItem1">
            <el-form-item label="货架名称:" prop="frameName">
              <el-input v-model="infosForm.frameName"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="queryItem1">
            <el-form-item label="所属仓库:">
              <el-input
                v-model="storageName"
                :disabled="subTitle == '修改货架'"
              ></el-input>
            </el-form-item>
          </div> -->
          <div class="queryItem1">
            <el-form-item label="所属仓库:">
              <el-select
                v-model="storage_id"
                filterable
                :disabled="subTitle == '修改货架'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storageAddr"
                  :key="item.id"
                  :label="item.storageName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="queryItem1">
            <el-form-item label="所属货区:" prop="storageCargoareaId">
              <el-select
                v-model="infosForm.storageCargoareaId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storageAreas_dia"
                  :key="item.id"
                  :label="item.cargoareaName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div class="queryItem1">
            <el-form-item label="所属货架:">
              <el-select
                v-model="infosForm.storageCargoareaFrameId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storageAreaChooseArr"
                  :key="item.cargoareaId"
                  :label="item.cargoareaName"
                  :value="item.cargoareaId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="footerbox">
        <el-button @click="submitInfo()" class="seniorbut">保存</el-button>
      </div>
    </el-dialog>

    <!-- 打印 -->
    <div class="diasBox">
      <el-dialog
        title="打印货架"
        :visible.sync="show_PrintCate"
        @close="closePrint"
        :modal-append-to-body="false"
      >
        <div class="printBox" ref="print">
          <div
            class="printItem"
            style="page-break-after: always"
            v-for="(item, index) in currentItemArr"
            :key="index"
          >
            <div class="printtop" style="height: 70px; line-height: 70px">
              {{ item.storageCargoareaFrameName }}
            </div>
            <div class="printBto">
              <img
                class="printImg"
                style="width: 280px; height: 100px; margin: 10px auto"
                :id="'printHj_' + index"
              />
            </div>
            <h2 style="margin: 0 auto 20px; text-align: center">
              {{ item.storageCargoareaFrameNumber }}
            </h2>
          </div>
        </div>
        <div slot="footer" class="dialog-footer footerbox">
          <el-button @click="billPrintClick()" class="seniorbut"
            >打 印</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { apiList, Api } from "@/assets/js/api";
import tools from "@/assets/js/tool";
import draggable from "vuedraggable"; //拖拽组件
import sorttable from "@/components/sortTemplate.vue";
import paging from "@/components/pagings.vue";
import JsBarcode from "jsbarcode"; //条形码
export default {
  inject: ["reload"],
  components: {
    sorttable,
    // mytables,
    draggable,
    paging,
  },
  data() {
    return {
      queryData: {
        cargoareaName: "",
        frameName: "",
        storageName: "",
      },
      // ================
      pageNum: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      size: 20, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      show_PrintCate: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      tableHeigth: "50vh",
      tabelHeadeTitle: [
        {
          name: "货架编号",
          field: "storageCargoareaFrameNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
        },
        {
          name: "货架名称",
          field: "storageCargoareaFrameName",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false,
        },
        {
          name: "货架票数",
          field: "packageCount",
          width: "100",
          sort: 2,
          isShow: true,
          isTotal: false,
        },
        {
          name: "所属货区",
          field: "cargoareaName",
          sort: 3,
          width: "120",
          isShow: true,
          isTotal: false,
        },
        {
          name: "所属仓库",
          field: "storageName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
        },
        {
          name: "创建时间",
          field: "frameCreateTime",
          width: "180",
          sort: 5,
          isShow: true,
          isTotal: false,
        },
      ],
      tableData: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      fullscreen: false,
      isActive: true, //输入框绑定动态class
      judge: false, //输入框绑定动态class
      MoreConditions: "更多条件", //输入框绑定动态class
      uploadUrl: "", //上传路径
      sortName: "模板名", //排序名
      pageGroupName: "cangkuhuojia", //页面标识   (注意这里,每个列表定义一个唯一的标识,自定义,设置表头或者下载需要用到)
      show_cate: false,
      infosForm: {
        number: "",
        storageCargoareaId: "", //货区id
        frameName: "",
      },
      infoRules: {
        frameName: [
          { required: true, message: "请输入货架名称", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入货架编码", trigger: "blur" },
        ],
        storageCargoareaId: [
          { required: true, message: "请选择货区", trigger: "blur" },
        ],
      },
      currentItemArr: [],
      storageAddr: [], // 仓库地址
      storageAreas: [], // 仓库货区
      storageAreas_dia: [], // 仓库货区(弹窗)
      storageAreaChooseArr: [],

      oldQueryArea: "",
      subTitle: "新建货架",
      storage_id: "",
      storageIds: "", //查询条件的仓库id
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.uploadUrl = this.common.uploadUrl;
    if (this.originalTabelHeadeTitle.length == 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.myTableHeard = this.tabelHeadeTitle;
    this.getStorageAddr();
  },
  mounted() {
    const that = this;
    this.getData();
    this.fetTableHeight();
  },
  watch: {
    storageIds(newVal, oldVal) {
      //console.log(newVal)
      this.getStorageAreas(newVal); //根据仓库id货区货区
    },
    storage_id(newVal, oldVal) {
      this.getStorageAreas(newVal, 1); //根据仓库id货区货区
    },
    queryData: {
      // handler(n) {
      //   if (this.oldQueryArea != n.storageName) {
      //     this.oldQueryArea = n.storageName;
      //     this.queryData.cargoareaName = "";
      //     this.getStorageAreas(n.storageName);
      //   }
      // },
      // deep: true,
    },
  },
  methods: {
    //打印
    billPrintClick() {
      let that = this;

      setTimeout(() => {
        that.$notModelprint(this.$refs.print);
      }, 10);
    },
    // 创建条形码
    createCode(id, data) {
      JsBarcode(id, data, {
        format: "code128", //选择要使用的条形码类型
        width: 3, //设置条之间的宽度
        height: 90, //高度
        displayValue: false, //是否在条形码下方显示文字
        // text: "456", //覆盖显示的文本
        fontOptions: "bold", //使文字加粗体或变斜体
        // font: "fantasy", //设置文本的字体
        // textAlign: "left", //设置文本的水平对齐方式
        // textPosition: "top", //设置文本的垂直位置
        textMargin: 10, //设置条形码和文本之间的间距
        fontSize: 24, //设置文本的大小
        background: "#ffffff", //设置条形码的背景
        lineColor: "#000", //设置条和文本的颜色。
        margin: 5, //设置条形码周围的空白边距
      });
    },
    closePrint() {
      this.getData();
    },

    // 打印按钮
    printHuoJia() {
      let that = this;
      if (this.currentItemArr.length < 1) {
        this.$message.warning("至少选择一个货架");
        return;
      }
      console.log(this.currentItemArr);

      this.show_PrintCate = true;
      this.$nextTick(() => {
        for (var i = 0; i < this.currentItemArr.length; i++) {
          //生成条形码
          that.createCode(
            "#printHj_" + i,
            this.currentItemArr[i].storageCargoareaFrameNumber
          );
        }
      });
    },
    //选择仓库
    changeStorageId(e) {
      // this.storageAreas = []; //清空货区
      this.queryData.cargoareaName = ""; //清空货区
      for (var i = 0; i < this.storageAddr.length; i++) {
        if (this.storageAddr[i].storageName == e) {
          this.storageIds = this.storageAddr[i].id;
          this.getData();
        }
      }
    },
    //选择货区
    changeHuoQue(e) {
      // cargoareaName
      // for (var i = 0; i < this.storageAreas.length; i++) {
      //   if (this.storageAreas[i].cargoareaName == e) {
      //     this.storageIds = this.storageAreas[i].id;

      //   }
      // }
      this.getData();
    },
    getStorageAddr() {
      // 获取仓库地址
      Api.getStorageList({}).then((res) => {
        if (res.data.status == "success") {
          this.storageAddr = res.data.result || [];
        }
      });
    },
    getStorageAreas(storageIds, type) {
      let types = type || "";
      // 获取货区
      Api.getStorageCargoareaChooseList({
        storageId: storageIds,
      }).then((res) => {
        if (res.data.status == "success") {
          if (types == "1") {
            //弹窗的货区
            this.storageAreas_dia = res.data.result || [];
          } else {
            // 列表查询字段的货区
            this.storageAreas = res.data.result || [];
          }
        }
      });
    },
    //弹窗关闭
    closebut() {
      this.infosForm = {
        number: "",
        storageCargoareaId: "",
        frameName: "",
      };
      this.storage_id = "";
      this.storageAreas_dia = [];
      this.show_cate = false;
    },
    addItem() {
      this.show_cate = true;
      this.subTitle = "新建货架";
      if (this.$refs.formCate) {
        this.$refs.formCate.resetFields();
      }
    },
    //删除
    deletebut() {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let currentItemArr = this.currentItemArr;
        let array = {};
        let storageCargoareaFrameIds = [];
        for (var i = 0; i < currentItemArr.length; i++) {
          storageCargoareaFrameIds.push(
            currentItemArr[i].storageCargoareaFrameId
          );
        }
        array.storageCargoareaFrameIds = storageCargoareaFrameIds;
        let sign = tools.getSign(array);

        array.sign = sign;
        Api.deleteStorageCargoareaFrame(array).then((res) => {
          if (res.data.status == "success") {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          }
        });
      });
    },
    //修改
    updateItem() {
      if (this.currentItemArr.length == 1) {
        this.show_cate = true;
        this.subTitle = "修改货架";
        const curItem = this.currentItemArr[0];

        this.infosForm.number = curItem.storageCargoareaFrameNumber; //仓库编号
        this.infosForm.storageCargoareaFrameId =
          curItem.storageCargoareaFrameId; //货架id
        this.infosForm.frameName = curItem.storageCargoareaFrameName; //货架名
        this.infosForm.storageCargoareaId = curItem.cargoareaId; //货区id
        this.storage_id = curItem.storageId; //仓库名

        this.getStorageAreas(curItem.storageId, "1"); //1==弹窗的列表
      } else {
        this.$message.warning("请选择一个需要修改的仓库货架");
      }
    },
    handleCommandTabs(m) {
      if (m == "a") {
        this.myModel();
      } else if (m == "b") {
        this.exportBtn();
      } else if (m == "c") {
        this.exportTemplateDownload();
      } else if (m == "d") {
        this.upLoadBtn();
      }
    },
    submitInfo(formName) {
      let self = this;
      this.$refs.formCate.validate((valid) => {
        if (valid) {
          let signParam = {};
          for (let item in self.infosForm) {
            signParam[item] = self.infosForm[item];
          }
          let sign = tools.getSign(signParam);
          signParam.sign = sign;
          if (this.subTitle == "修改货架") {
            // 修改
            Api.updateStorageCargoareaFrame(signParam).then((res) => {
              this.$message.success(res.data.message || "操作成功");
              self.show_cate = false;
              self.reload();
            });
          } else {
            Api.addstorageCargoareaFrame(signParam).then((res) => {
              if (res.data.status == "success") {
                this.$message.success(res.data.message || "操作成功");
                self.show_cate = false;
                self.reload();
              }
            });
          }
        }
      });
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */
    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    /**
     * =========================按钮部分的方法=>结束??????????????????????????????????
     */

    // ===============================================导出部分=开始======
    // 上传导出模板
    uploadSectionFile(param) {
      //console.log(param);
      const file = param.file,
        fileName = file.name;

      // 根据后台需求数据格式
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      form.append("fileName", fileName);
      let signArr = [
        {
          key: "fileName",
          val: fileName,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      form.append("sign", sign);
      // 项目封装的请求方法，下面做简单介绍
      Api.uploadFile(form)
        .then((res) => {
          if (res.data.status == "success") {
            let fileName = res.data.result.fileName;

            let signArr = [
              {
                key: "groupName",
                val: this.pageGroupName,
              },
              {
                key: "templateName",
                val: this.sortName,
              },
              {
                key: "fileName",
                val: fileName,
              },
            ];
            let sign_ = tools.getMD5Sign(signArr);
            Api.saveExportTemplate({
              groupName: this.pageGroupName,
              templateName: this.sortName,
              fileName: fileName,
              sign: sign_,
            }).then((res) => {
              this.$message.success(res.data.message || "更新成功");
              this.show_upload = false;
            });
          }
        })
        .catch((err) => {});
    },

    // 下载用户导出模板
    exportTemplateDownload() {
      var fieldName = this.fieldName;
      var head = this.head;
      if (head.length == 0) {
        let fieldNames = [];
        let heads = [];
        for (var i = 0; i < this.myTableHeard.length; i++) {
          if (this.myTableHeard[i].isShow) {
            fieldNames.push(this.myTableHeard[i].field);
            heads.push(this.myTableHeard[i].name);
          }
        }
        fieldName = fieldNames;
        head = heads;
      }
      //加密数组格式
      let signArr = [
        {
          key: "fieldName",
          val: fieldName,
        },
        {
          key: "head",
          val: head,
        },
      ];
      let sign = tools.getMD5Sign(signArr);
      let param = {
        fieldName: fieldName,
        head: head,
        sign: sign,
      };
      Api.exportTemplateDownload(param).then((res) => {
        let downloadurl = res.data.result.fileUrl || "";
        //下载(这里其实是直接访问)
        var a = document.createElement("a");
        a.setAttribute("href", downloadurl);
        a.setAttribute("target", "_blank");
        a.click();
      });
    },
    // 真正导出
    templateDataExport(customizedExportId) {
      let that = this;
      let datas = that.tableData;
      let parm = {
        customizedExportId: customizedExportId, //模板id
        className: that.className,
        data: datas,
      };
      let signarr = tools.getSignArr(parm);
      let signs_e = tools.getMD5Sign(signarr);
      Api.templateDataExport({
        customizedExportId: customizedExportId,
        className: that.className,
        data: JSON.stringify(datas),
        sign: signs_e,
      }).then((res) => {
        //下载(这里其实是直接访问)
        let downloadurl = res.data.result.fileUrl;
        var a = document.createElement("a");
        a.setAttribute("href", downloadurl);
        a.setAttribute("target", "_blank");
        a.click();
      });
    },
    // 上传按钮
    upLoadBtn() {
      this.show_upload = true;
    },
    // 点击导出按钮
    exportBtn() {
      let that = this;
      let fieldName = [];
      let head = [];
      for (var i = 0; i < this.myTableHeard.length; i++) {
        if (this.myTableHeard[i].isShow) {
          fieldName.push(this.myTableHeard[i].field);
          head.push(this.myTableHeard[i].name);
        }
      }
      this.fieldName = fieldName;
      this.head = head;

      // 1,先获取用户导出模板
      Api.getUserExportTemplate({
        groupName: this.pageGroupName,
      }).then((res) => {
        if (res.data.result && res.data.result[0].customizedExportId) {
          // 有自定义模板

          let customizedExportId = res.data.result[0].customizedExportId;
          that.templateDataExport(customizedExportId);
        } else {
          //没有自定义模板,就是下载一个
          tools.dynamicExport(
            this.myTableHeard,
            this.className,
            this.tableData,
            "仓库货架列表"
          );
        }
      });
    },
    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    // 重置table高度
    resetHeight() {
      return new Promise((resolve, reject) => {
        this.tableHeigth = 0;
        resolve();
      });
    },
    // 设置table高度
    fetTableHeight() {
      this.resetHeight().then((res) => {
        this.tableHeigth = this.getHeight();
        // console.log(this.tableHeigth + "表格高度");
        this.$nextTick(() => {
          this.$refs.mytable.doLayout();
        });
      });
    },
    // 获取表格高度
    getHeight() {
      let windonHeight = document.body.clientHeight;
      let queryHeigth;
      let btnListHeight = this.$refs.btnList.offsetHeight + 16; // 按钮列表  16==上下的margin
      if (this.judge == true) {
        queryHeigth = this.$refs.queryCriteria.offsetHeight; //查询框
      } else {
        queryHeigth = 50;
      }
      let pagsHeigth = 40; //分页组件
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60 + 10; //60是顶部导航 ,10==预留空位
      return Math.floor(windonHeight - otherHeight) || "50vh"; //
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 刷新页面==>
    reload_s() {
      this.reload(); //App.Vue里面的方法
    },
    // 获取数据
    getData() {
      let formData = this.queryData;
      formData.pageStart = this.pageNum;
      formData.pageTotal = this.size;
      this.currentItemArr = [];
      Api.getStorageCargoareaFrameList(formData).then((res) => {
        if (res.data.status == "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.total = res.data.result.pageCount || 0;
        }
      });
    },
    // 查询按钮
    queryBtn_ok() {
      this.pageNum = 1;
      this.getData();
    },
    // 重置按钮
    queryBtn_cz() {
      this.queryData = {
        cargoareaName: "",
        frameName: "",
        storageName: "",
      };
      this.storageIds = "";
    },
    //输入框绑定动态class
    more() {
      this.isActive = !this.isActive;
      this.judge = !this.judge;
      this.fetTableHeight();
      if (this.judge == false) {
        this.MoreConditions = "更多条件";
      } else {
        this.MoreConditions = "收起条件";
      }
    },
    // 获取自定义的排序,没有就用默认的
    getGroupFindFieldSort() {
      let that = this;
      Api.getGroupFindFieldSort({
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      }).then((res) => {
        let arr = res.data.result || [];
        if (arr.length > 0) {
          if (arr[0].sortObject) {
            that.myTableHeard = JSON.parse(arr[0].sortObject);
            this.sortName = arr[0].sortName;
          }
        } else {
          that.myTableHeard = that.tabelHeadeTitle;
        }
        let totalArr = [];
        //提取需要合计的字段
        for (var i = 0; i < that.myTableHeard.length; i++) {
          if (that.myTableHeard[i].isTotal) {
            totalArr.push(that.myTableHeard[i].field);
          }
        }
        that.totalArr = totalArr;
      });

      that.$nextTick(() => {
        that.$refs.mytable.doLayout();
      });
    },
    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return tools.mathToFixed(tools.add(prev, curr), 2);
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },

    // 设置模板按钮
    myModel() {
      let that = this;
      that.show_sortTableHeard = true;
      that.tabelHeadeTitle = JSON.parse(JSON.stringify(that.myTableHeard));
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    // 表格选择事件
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.currentItemArr = e;
      } else {
        this.currentItemArr = [];
      }
    },

    // 排序==>取消按钮
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let signs = [
        {
          key: "sortName",
          val: this.sortName, //模板名称
        },
        {
          key: "groupName",
          val: this.pageGroupName, //页面标识
        },
        {
          key: "sortObject",
          val: JSON.stringify(sortObject),
        },
      ];

      let sign = tools.getMD5Sign(signs);

      let param = {
        // apiPath: apiList.api_packageList, //综合查询接口路径
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
        sign: sign,
      };
      Api.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getGroupFindFieldSort();
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗
    closeDias(e) {
      this.show_sortTableHeard = e;
    },
    //分页
    handleSizeChange(val) {
      this.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.printBox {
  width: 100%;
  box-sizing: border-box;
  text-align: center;

  .printItem {
    width: 300px;
    height: 300px;
    border: 1px solid #d7d7d7;
    margin: 50px auto;

    .printtop {
      height: 70px;
      line-height: 70px;
      border-bottom: 1px solid #d7d7d7;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      box-sizing: border-box;
    }
    .printBto {
      text-align: center;
      height: 140px;
      line-height: 140px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      // .printImg {

      // }
    }
  }
}
// 打印预览格式
@media print {
  // 去掉页眉页脚
  @page {
    margin: 0 10mm;
  }
  .printItem {
    width: 300px;
    height: 300px;
    border: 1px solid #d7d7d7;
    margin: 50px auto;
  }
  .printtop {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d7d7d7;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    box-sizing: border-box;
  }
  .printBto {
    text-align: center;
    height: 200px;
    line-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
}
.diasBox {
  ::v-deep {
    .el-dialog__body {
      max-height: 70vh;
      overflow: auto;
    }
  }
}

.tableBox {
  height: calc(100% - 260px);
}
.colorStyle {
  color: #f00;
}
.formbox ::v-deep {
  width: 80%;
  margin: 0 auto;
}
.headebut {
  width: 80%;
  margin: 0 auto;
  padding-left: 100px;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
</style>
